const publicAuthActionPaths = new Set([
  '/',
  '/preview',
  '/docs',
  '/cookie-policy',
  '/cookie-policy.html',
  '/privacy-policy',
  '/privacy-policy.html',
  '/terms-of-service',
  '/terms-of-service.html',
  '/acceptable-use-policy',
  '/acceptable-use-policy.html',
  '/privacy-requests',
]);

export const shouldShowPublicAuthActions = (
  activePath: string,
  isEntryAuthFlow: boolean,
): boolean => {
  if (isEntryAuthFlow) return false;
  return publicAuthActionPaths.has(activePath);
};
